import React, {useState, useEffect} from 'react';
import Work from './pages/work';
import Home from './pages/home';
import About from './pages/about';
import Contact from './pages/contact';
import Menu from './pages/menu';
import Error from './pages/error';
import Loader from './pages/loader';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';


function App() {
  useEffect(() => {

    const $dot = document.querySelector('.cursor-dot');
    const $outline = document.querySelector('.cursor');

    const cursor = {
      delay: 8,
      _x: 0,
      _y: 0,
      endX: window.innerWidth / 2,
      endY: window.innerHeight / 2,
      cursorVisible: true,
      cursorEnlarged: false,

      init: function () {
        this.dotSize = $dot.offsetWidth;
        this.outlineSize = $outline.offsetWidth;
        this.setupEventListeners();
        this.animateDotOutline();
      },

      setupEventListeners: function () {
        const self = this;
        document.querySelectorAll('a').forEach(function (el) {
          el.addEventListener('mouseover', function () {
            self.cursorEnlarged = true;
            self.toggleCursorSize();
            $outline.style.backgroundColor = '#7781A6';
          });
          el.addEventListener('mouseout', function () {
            self.cursorEnlarged = false;
            self.toggleCursorSize();
            $outline.style.backgroundColor = '';
          });
        });
        document.querySelectorAll('.active').forEach(function (el) {
          el.addEventListener('mouseover', function () {
            self.cursorEnlarged = true;
            self.toggleCursorSize();
            $outline.style.backgroundColor = '#7781A6';
          });
          el.addEventListener('mouseout', function () {
            self.cursorEnlarged = false;
            self.toggleCursorSize();
            $outline.style.backgroundColor = '';
          });
        });
        document.addEventListener('mousedown', function () {
          self.cursorEnlarged = true;
          self.toggleCursorSize();
        });
        document.addEventListener('mouseup', function () {
          self.cursorEnlarged = false;
          self.toggleCursorSize();
        });
        document.addEventListener('mousemove', function (e) {
          self.cursorVisible = true;
          self.toggleCursorVisibility();
          self.endX = e.pageX;
          self.endY = e.pageY;
          $dot.style.top = self.endY + 'px';
          $dot.style.left = self.endX + 'px';
        });
        document.addEventListener('mouseenter', function () {
          self.cursorVisible = true;
          self.toggleCursorVisibility();
          $dot.style.opacity = 1;
          $outline.style.opacity = 1;
        });
        document.addEventListener('mouseleave', function () {
          self.cursorVisible = true;
          self.toggleCursorVisibility();
          $dot.style.opacity = 0;
          $outline.style.opacity = 0;
        });
      },

      animateDotOutline: function () {
        const self = this;
        self._x += (self.endX - self._x) / self.delay;
        self._y += (self.endY - self._y) / self.delay;
        $outline.style.top = self._y + 'px';
        $outline.style.left = self._x + 'px';
        requestAnimationFrame(this.animateDotOutline.bind(self));
      },

      toggleCursorSize: function () {
        const self = this;
        if (self.cursorEnlarged) {
          $dot.style.transform = 'translate(-50%, -50%) scale(0.75)';
          $outline.style.transform = 'translate(-50%, -50%) scale(1.5)';
        } else {
          $dot.style.transform = 'translate(-50%, -50%) scale(1)';
          $outline.style.transform = 'translate(-50%, -50%) scale(1)';
        }
      },

      toggleCursorVisibility: function () {
        const self = this;
        if (self.cursorVisible) {
          $dot.style.opacity = 1;
          $outline.style.opacity = 1;
        } else {
          $dot.style.opacity = 0;
          $outline.style.opacity = 0;
        }
      },
    };

    cursor.init();

   

    // projectItems.forEach(function (item) {
   

    // Clean up event listeners
    return () => {
   
    };
  }, []);

  
 

  return (
    <Router>
      
        <Routes>
          <Route exact path="" element={<Home />} />
          <Route exact path="/work" element={<Work />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/contact" element={<Contact />} />
          <Route exact path="/menu" element={<Menu />} />
          <Route path="*" element={<Error />} />
        </Routes>
      
    </Router>
  );
}

export default App;
